import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { GalleryState } from '../../state/gallery.state';
import { Observable } from 'rxjs';
import { GalleryViewMode } from '../../models/gallery-view-mode.enum';
import { GalleryActions } from '../../state/gallery.actions';
import { SortModel } from 'src/app/shared/components/sort/sort.component';

@Component({
  selector: 'app-gallery-controls',
  templateUrl: './gallery-controls.component.html',
  styleUrls: ['./gallery-controls.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GalleryControlsComponent implements OnInit {
  galleryViewMode = GalleryViewMode;
  
  @Select(GalleryState.getViewMode)
  viewMode$: Observable<GalleryViewMode>;

  @Select(GalleryState.getSort)
  sort$: Observable<SortModel>;

  @Select(GalleryState.getSortOptions)
  sortOptions$: Observable<SortModel>;

  constructor(
    private store: Store
  ) { }

  ngOnInit() {
  }

  handleSort(sort: SortModel) {
    this.store.dispatch(new GalleryActions.SetSort(sort));
  }

  toggleView(viewMode: GalleryViewMode) {
    this.store.dispatch(new GalleryActions.SetViewMode(viewMode));
  }
}
